import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { EditStoreProps } from '@/main/store/@types/edit.d';

import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { EmailAttachments, CRUMB_LABEL_KEY, DEPENDENT_TABLES, NAME } from '../constants';
import { apiProvider } from '../api';

interface smsDropdownItem extends DropdownItem {
	SmsTemplate: string
}
interface dmsFunctionDropdownItem extends DropdownItem {
	BusinessLine: string
}
interface emailDropdownItem extends DropdownItem {
	TemplateContent: string
}
const dropdownList = {
	DMSFunction: [] as dmsFunctionDropdownItem[],
	BusinessLine: [],
	SMSTemplate: [] as smsDropdownItem[],
	DMSFunctionByBusinessLine: [] as dmsFunctionDropdownItem[],
	EmailTemplate: [] as emailDropdownItem[],
	Brand: [],
	AllDMSFunctions: [] as dmsFunctionDropdownItem[],
};

const edit = {
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VstupPracIdText: null as string | null,
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	EditPracIdText: null as string | null,
	Id: null as number | null,
	TypeOfCommunicationId: null as number | null,
	Communication: null as string | null,
	BusinessLine: null as string | null,
	DMSFunctionId: null as number | null,
	BrandId: null as string | null,
	DescriptionOfEvent: null as string | null,
	Status: null as number | null,
	SMSTemplateId: null as string | null,
	SMSTemplate: null as string | null,
	EmailBody: null as string | null,
	EmailTemplateId: null as number | null,
	EmailTemplate: null as string | null,
	EmailTo: null as string | null,
	EmailCc: null as string | null,
	EmailBcc: null as string | null,
	EmailSubject: null as string | null,
	FromEmailAddress: null as string | null,
};

const localState = {
	isNdNrChosen: null as boolean | null,
};


export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[EmailAttachments]: {
			loadByEntityId: true,
			filter(state) { return { Id: state.props.id }; },
		},
	},
	edit,
	localState,
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	} as EditStoreProps,
});
